import type { Client } from '@efdigital/ll-addon-data';
import { type TemplateOnlyComponent } from '@ember/component/template-only';

interface Signature {
  Args: {
    client: Client;
    uniqueId: string;
    isReadOnly: boolean;
  };
}

const BrandingSection: TemplateOnlyComponent<Signature> = <template>
  <h3 class="gud-eyebrow">Branding</h3>
  <fieldset disabled={{@isReadOnly}} class="mb-4">
    <div class="mb-3">
      <label for="{{@uniqueId}}-branding" class="form-label">Branding identifier</label>
      <input
        id="{{@uniqueId}}-branding"
        name="branding"
        type="text"
        class="form-control"
        value={{@client.branding}}
        placeholder="Branding identifier"
      />
      <div class="form-text">
        If the client requires custom branding (colors, logo, etc.), this will
        be implemented by developers in the digital team.<br />
        They will provide a branding identifier which can be applied here.
      </div>
    </div>
  </fieldset>
</template>;

export default BrandingSection;
